import React, { useEffect, useState } from 'react';
import { XCircle, ArrowLeft, ShoppingBag } from 'lucide-react';
import Layout from '../Layout';
import { getOrderByDocumentId, cancelOrder } from '../../helpers/order';

const OrderCancelledPage = () => {
    const [orderInfo, setOrderInfo] = useState({
        orderId: null,
        cancelled: false
    });

    useEffect(() => {
        // Get the search parameters from the URL
        const searchParams = new URLSearchParams(window.location.search);
        
        // Get specific parameters
        const orderId = searchParams.get('order');
        const cancelled = searchParams.get('cancelled') === 'true';

        setOrderInfo({
            orderId,
            cancelled
        });
    }, []);

    useEffect(() => {
        deleteOrder();
    }, [orderInfo]);

    const deleteOrder = async () => {
        try{
            const order = await getOrderByDocumentId(orderInfo.orderId);
            if(!order){
                return;
            }
            const orderItems = order?.order_items;

            // console.log('Order: ',order);
            // console.log('Order items: ',orderItems);

            await cancelOrder(order, orderItems);
        }catch(e){
            console.error(e);
        }
    };
    
    return (
        <Layout>
            <div className="bg-light py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6">
                            <div className="card shadow-sm">
                                <div className="card-body text-center p-5">
                                    <XCircle className="text-danger mb-4" size={64} />

                                    <h1 className="display-6 fw-bold mb-3">Commande Annulée</h1>
                                    <p className="lead text-muted mb-4">
                                        Votre commande a été annulée avec succès.
                                        Si vous avez des questions, n'hésitez pas à nous contacter.
                                    </p>

                                    <div className="d-grid gap-3 d-sm-flex justify-content-sm-center">
                                        <a href="/" className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2">
                                            <ArrowLeft size={20} />
                                            Retour à l'accueil
                                        </a>
                                        <a href="/services/location" className="btn btn-primary d-flex align-items-center justify-content-center gap-2">
                                            <ShoppingBag size={20} />
                                            Continuer mes achats
                                        </a>
                                    </div>

                                    <div className="mt-4 pt-3 border-top">
                                        <p className="small text-muted mb-0">
                                            Besoin d'aide ? <a href="/contact" className="text-decoration-none">Contactez notre service client</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default OrderCancelledPage;